import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin } from '../common'

$(init)

async function init () {
  let $page = $('#premium-page')
  if ($page.length == 0) {
    return
  }
  try {
    let plans = (await get_json('/premium/get-plans')).data
    $page.find('.loading-indicator').addClass('d-none')
    let $plans = $('#plans')
    $plans.removeClass('d-none')
    $plans.html('')
    $plans.append(eval_html_template('#plan-template', {
      isfree: true,
      label: 'Free',
      price: '0',
      listings: '50',
    }))
    for (let plan of plans) {
      $plans.append(eval_html_template('#plan-template', plan))
    }
    $plans.on('click', '.buynow-btn', async ($evt) => {
      try {
        let plan_id = $($evt.target).data('plan-id')
        if (!plan_id) {
          console.error('data-plan-id is not defined!', $evt.target)
          return
        }
        let myinfo = await get_myinfo()
        let loggedin = has_user_loggedin(myinfo)
        if (!loggedin) {
          $(document).trigger('x-show-login-modal')
          return
        }
        let data = await post_json('/premium/paypal-create-order', { plan_id })
        window.location = `/premium/order/?id=${data.order_id}`
      } catch (err) {
        $page.find('.loading-indicator').addClass('d-none')
        alert_error(err)
      }
    })
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
